import { getAuthHTTPClient } from '@elliemae/pui-app-sdk';

export const endSession = async ({
  token,
}: {
  token: string;
}): Promise<void> => {
  await getAuthHTTPClient().delete(`/encompass/v1/auth/sessions/${token}`);
};
